import { IDAccessor } from './DataTableTypes';

export const getRowId = <D extends object>(row: D, idAccessor: IDAccessor<D>): string => {
  const value = row[idAccessor];
  if (typeof value === 'string') {
    return value;
  }
  throw new TypeError(
    `Expected id to be string but got ${typeof value}. Check idAccessor (${idAccessor}) points to unique string value in your data`
  );
};
